import React from 'react';
import { PageHeader } from '../components/shared/PageHeader';
import { ProcessSteps } from '../components/shared/ProcessSteps';
import { EventCountdown } from '../components/shared/EventCountdown';
import { CtaBand } from '../components/shared/CtaBand';
import { useLanguage } from '../contexts/LanguageContext';
import { useSeo } from '../hooks/useSeo';
export function Process() {
  const {
    t,
    lang
  } = useLanguage();
  const p = t.process;
  useSeo({
    ...t.common.seo.process,
    lang
  });
  return <main data-id="element-491" data-mp="3r3aeumf6zjgl">
      <PageHeader eyebrow={p.eyebrow} title={p.title} description={p.description} data-id="element-492" data-mp="3r30ogxq8jaad" />
      <section className="bg-white py-16 sm:py-20" data-id="element-493" data-mp="3dbvuoc9jtc7y">
        <div className="mx-auto grid max-w-7xl gap-14 px-5 sm:px-8 lg:grid-cols-12 lg:gap-16" data-id="element-494" data-mp="3db3zh2jv5gi7">
          <div className="pl-5 lg:col-span-7" data-id="element-495" data-mp="3hb4o1g0of82z">
            <ProcessSteps layout="column" data-id="element-496" data-mp="8wma4xo20ybg" />
          </div>
          <div className="lg:col-span-5" data-id="element-497" data-mp="8v1f76xtvdd2">
            <div className="lg:sticky lg:top-28" data-id="element-498" data-mp="doe4ljabzo6v">
              <EventCountdown data-id="element-499" data-mp="dp5o3vqnlvgs" />
            </div>
          </div>
        </div>
      </section>
      <CtaBand data-id="element-500" data-mp="3nalym5qv4pcq" />
    </main>;
}